// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "vendors" + "-" + "d8192e0cd4b8ce6652b7" + ".js";
};